// extracted by mini-css-extract-plugin
export default {"headerContainer":"PmsMessage_headerContainer__ap8vP","logo":"PmsMessage_logo__RsN--","primaryButton":"PmsMessage_primaryButton__r3k53","text":"PmsMessage_text__oz2cj"};